<div class="nomination-header-container padding-bottom">
    <h3 class="nomination-header"> UPDATE YOUR CHOICE OF NOMINATION</h3>
    <div class="nomination-header-close-btn">
        <button mat-icon-button (click)="closeDialog()" class="close-btn font-12">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<hr/>
<ul class="mobile-pad">
    <div>
        <li class="list-items"> As per SEBI guidelines, all investors are required to provide their Choice of Nomination for their Demat Account.
        </li>
        <li class="list-items"> Our records indicate that you have not yet submitted your nomination or opted out.</li>
        <li class="list-items"> Providing a nominee ensures smooth transmission of your securities to your chosen person in case of unforeseen events. </li>
    </div>
</ul>

<p>
    <strong>*If you've already completed this process, please ignore this message.</strong>
</p>

<div class="nomination-button flex-centered-container">
    <button type="button" mat-flat-button class="button-container fit-content" color="accent" tabindex="0" (click)="openNomineeForm()" >Add Nomination</button>
    <button type="button" mat-flat-button class="button-container fit-content opt-out-button" tabindex="0" (click)="openOptOutPopup()" >Opt Out</button>
    <button type="button" mat-flat-button class="button-container fit-content close-button" tabindex="0" (click)="closeDialog()">Close</button>
</div>
